export default function About() {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-[1440px] mx-auto px-20">
        <div className="flex items-center gap-20">
          {/* Left Visual */}
          <div className="w-[40%]">
            <div className="rounded-[40px] bg-[#87CEEB] overflow-hidden shadow-[0_12px_40px_rgba(0,0,0,0.08)]">
              <div className="w-full h-[560px] flex items-center justify-center p-12">
                <img
                  src="https://public.readdy.ai/ai/img_res/5d9d25d1217d54695125d0855e04870b.jpg"
                  alt="Development Team"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="w-[60%] pl-20">
            <div className="uppercase text-xs font-semibold tracking-[3px] text-[#4A9FFF] mb-6">
              ABOUT US
            </div>
            <h3 className="text-5xl font-bold text-[#1A1A1A] leading-tight mb-8">
              Team of Experts
            </h3>
            <p className="text-lg text-[#555555] leading-relaxed max-w-[600px]">
              At FRENKI D.O.O., we are passionate about creating innovative mobile solutions that make a difference. Our team combines years of experience in iOS development with a deep understanding of user needs and security requirements.
            </p>
            <p className="text-lg text-[#555555] leading-relaxed max-w-[600px] mt-6">
              We specialize in developing applications that not only meet the highest technical standards but also provide intuitive and seamless user experiences. From concept to deployment, we ensure every detail is crafted with precision and care.
            </p>
            <p className="text-lg text-[#555555] leading-relaxed max-w-[600px] mt-6">
              Our commitment to excellence drives us to continuously innovate and improve, delivering products that users can trust and rely on every day.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}